import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './theme/tokens.css';
import './theme/site.css';
import App from './App';
import configureStore from './redux';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import * as serviceWorker from './serviceWorker';

import axios from 'axios';
import { getAccessToken } from './auth/AuthService'

// Add a request interceptor
axios.interceptors.request.use(
    config => {
        const token = getAccessToken();
        if (token) {
            //config.headers['Authorization'] = 'Bearer ' + token;
        }
        return config;
    },
    error => {
        Promise.reject(error)
    }
);

const store = configureStore();

// NOTE: the legacy shopify-buy (js-buy 2.11) bootstrap was removed here — its
// Checkout-API GraphQL is rejected by current Shopify and threw on every page.
// The catalog now uses the Storefront API directly (see src/catalog/storefront.js).

ReactDOM.render(
    <React.StrictMode>
        <Provider store={store}>
            <BrowserRouter basename={"/"} forceRefresh="true">
                <App/>
            </BrowserRouter>
        </Provider>
    </React.StrictMode>,
    document.getElementById('root')
);

serviceWorker.unregister();
